import { render, staticRenderFns } from "./OfficeServeList.vue?vue&type=template&id=5cd46f59&scoped=true&"
import script from "./OfficeServeList.vue?vue&type=script&lang=js&"
export * from "./OfficeServeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd46f59",
  null
  
)

export default component.exports